import React from 'react';
import {Button, ButtonGroup} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencilAlt, faSearch, faTrash} from "@fortawesome/free-solid-svg-icons";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";

interface IProps {
  onDetail?: (e: any) => void;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  disabledRemove?: boolean;
  disabledDetail?: boolean;
  disabledEdit?: boolean;
  detailIcon?: IconDefinition;
}

const ColumnAction = ({ onDetail, onEdit, onRemove, disabledEdit, disabledDetail, disabledRemove, detailIcon = faSearch }: IProps) => {
  return (
    <div className="text-center">
      <ButtonGroup>
        {
          onDetail &&
          <Button
            color="primary"
            outline
            size="sm"
            onClick={(e: any) => {
              e.preventDefault();
              onDetail && onDetail(e);
            }}
            disabled={disabledDetail}
          >
            <FontAwesomeIcon icon={detailIcon}/>
          </Button>
        }
        {
          onEdit &&
          <Button
            size="sm"
            outline
            color="primary"
            onClick={(e: any) => {
              e.preventDefault();
              onEdit && onEdit(e);
            }}
            disabled={disabledEdit}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Button>
        }
        {
          onRemove &&
          <Button
            size="sm"
            outline
            color="danger"
            hidden={!onRemove}
            onClick={(e: any) => {
              e.preventDefault();
              onRemove && onRemove(e);
            }}
            disabled={disabledRemove}
          >
            <FontAwesomeIcon icon={faTrash}/>
          </Button>
        }
      </ButtonGroup>
    </div>
  );
};
export default ColumnAction;
